// Module
var code = `<pre class="language-{{scriptType}}">
<code class="hljs hljs-javascript code-snippet"></code>
        </pre>
`;
// Exports
module.exports = code;